module.exports = __webpack_public_path__ + "img/lens-174-minus-03.60c599a0.png";